import Button from '@/components/Button';
import PageHeader from '@/components/PageHeader';
import SearchForm from '@/components/search/SearchForm';
import useSearch from '@/components/search/useSearch';
import Breadcrumbs from '@/modules/admin/components/Breadcrumbs';
import SupplierTable from '@/modules/admin/components/SupplierTable';
import { SupplierAddPath } from '@/modules/admin/paths';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import { HomePath } from '@/routing/paths';
import { ArrowRightStartOnRectangleIcon } from '@heroicons/react/24/outline';
import { PlusIcon } from '@heroicons/react/24/solid';
import { useNavigate } from 'react-router-dom';

interface Supplier {
  id: string;
  organizationId: string;
}

const SupplierList = () => {
  const navigate = useNavigate();
  const { switchContext } = useAuth();

  const { searchQuery, page, handleSearchSubmit, handlePageChange, setSearchQuery } = useSearch();

  const handleSupplierSelect = (supplier: Supplier) => {
    void (async () => {
      try {
        await switchContext({
          organizationId: supplier.organizationId,
          supplierId: supplier.id,
        });
        navigate(HomePath);
      } catch (err) {
        console.error('Failed to switch context:', err);
      }
    })();
  };

  return (
    <>
      <Breadcrumbs />

      <PageHeader title="Suppliers">
        <Button
          to={SupplierAddPath}
          icon={<PlusIcon className="h-5 w-5 mr-1" />}
          variant="secondary"
        >
          Create Supplier
        </Button>
      </PageHeader>

      <SearchForm
        onSubmit={handleSearchSubmit}
        onChange={setSearchQuery}
        value={searchQuery}
        placeholder="Search by name"
      />

      <SupplierTable
        searchQuery={searchQuery}
        page={page}
        onChangePage={handlePageChange}
        onSelectSupplier={handleSupplierSelect}
        onSelectSupplierElement={
          <Button
            variant="secondary"
            size="sm"
            icon={<ArrowRightStartOnRectangleIcon className="w-5 h-5" />}
          >
            Enter Supplier
          </Button>
        }
      />
    </>
  );
};

export default SupplierList;
